<template>
  <div class="invoice-printer-settings">
    <div class="row">
      <!-- Config Column -->
      <div class="col-lg-7 border-right pr-4">
        <div class="settings-card border-0 p-0 shadow-none">
          <div class="card-header border-0 bg-transparent p-0 mb-4 d-flex justify-content-between align-items-center">
            <h3 class="h5 mb-0"><i class="fas fa-print mr-2"></i> Thiết lập hiển thị Hóa đơn</h3>
          </div>

          <div class="card-body p-0">
            <!-- Group: Cửa hàng -->
            <div class="settings-section mb-4">
              <h4 class="h6 font-weight-bold text-primary border-bottom pb-2 mb-3">Thông tin cửa hàng</h4>
              <div class="settings-grid d-flex flex-wrap">
                <div v-for="key in storeFields" :key="key" class="setting-item-van d-flex justify-content-between align-items-center w-50 mb-3 pr-3">
                  <label class="mb-0 small">{{ fieldLabels[key] }}</label>
                  <van-switch v-model="localData[key]" @input="update" size="20px" color="#304ffe" />
                </div>
              </div>
            </div>

            <!-- Group: Khách hàng -->
            <div class="settings-section mb-4">
              <h4 class="h6 font-weight-bold text-primary border-bottom pb-2 mb-3">Thông tin khách hàng</h4>
              <div class="settings-grid d-flex flex-wrap">
                <div v-for="key in customerFields" :key="key" class="setting-item-van d-flex justify-content-between align-items-center w-50 mb-3 pr-3">
                  <label class="mb-0 small">{{ fieldLabels[key] }}</label>
                  <van-switch v-model="localData[key]" @input="update" size="20px" color="#304ffe" />
                </div>
              </div>
            </div>

            <!-- Group: Nội dung -->
            <div class="settings-section mb-4">
              <h4 class="h6 font-weight-bold text-primary border-bottom pb-2 mb-3">Nội dung & Bảng sản phẩm</h4>
              <div class="settings-grid d-flex flex-wrap">
                <div v-for="key in orderAndProductFields" :key="key" class="setting-item-van d-flex justify-content-between align-items-center w-50 mb-3 pr-3">
                  <label class="mb-0 small">{{ fieldLabels[key] }}</label>
                  <van-switch v-model="localData[key]" @input="update" size="20px" color="#304ffe" />
                </div>
              </div>
            </div>

            <!-- Group: Thanh toán -->
            <div class="settings-section mb-4">
              <h4 class="h6 font-weight-bold text-primary border-bottom pb-2 mb-3">Tổng kết & Thanh toán</h4>
              <div class="settings-grid d-flex flex-wrap">
                <div v-for="key in paymentFields" :key="key" class="setting-item-van d-flex justify-content-between align-items-center w-50 mb-3 pr-3">
                  <label class="mb-0 small">{{ fieldLabels[key] }}</label>
                  <van-switch v-model="localData[key]" @input="update" size="20px" color="#304ffe" />
                </div>
              </div>
            </div>

            <!-- Group: Khổ giấy & Lời chào -->
            <div class="settings-section mb-4">
              <h4 class="h6 font-weight-bold text-primary border-bottom pb-2 mb-3">Giấy in & Lời chào</h4>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="small font-weight-bold d-block mb-1">Khổ giấy in nhiệt</label>
                  <select v-model="localData.paperSize" @change="update" class="form-control form-control-sm">
                    <option value="58mm">Khổ K58 (58mm)</option>
                    <option value="80mm">Khổ K80 (80mm)</option>
                    <option value="A5">Khổ A5 (148mm)</option>
                  </select>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="small font-weight-bold d-block mb-1">Số bản in / đơn</label>
                  <input type="number" v-model.number="localData.printCopies" @change="update" class="form-control form-control-sm" min="1">
                </div>
                <div class="col-12">
                   <div class="d-flex justify-content-between align-items-center mb-1">
                      <label class="small font-weight-bold mb-0">Lời chào chân trang</label>
                      <van-switch v-model="localData.showFooterNote" @input="update" size="18px" color="#304ffe" />
                   </div>
                   <textarea v-model="localData.footerNote" @change="update" class="form-control form-control-sm" rows="2" placeholder="Cảm ơn quý khách..."></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Preview Column -->
      <div class="col-lg-5">
        <div class="preview-header mb-3 text-center">
            <span class="badge badge-dark p-2"><i class="fas fa-eye mr-1"></i> XEM TRƯỚC HÓA ĐƠN</span>
        </div>
        <div class="preview-container bg-light p-4 d-flex justify-content-center border rounded shadow-inner" style="min-height: 500px; max-height: 600px; overflow-y: auto;">
            <BillTemplate :order="sampleOrder" :settings="localData" :system="systemData" />
        </div>
        <div class="text-center mt-2 small text-muted">
            Hóa đơn sẽ được in ra theo mẫu này trên máy in {{ localData.paperSize }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BillTemplate from '../reports/BillTemplate.vue';

export default {
  name: 'InvoicePrinterSettings',
  components: {
    BillTemplate
  },
  props: {
    data: Object,
    systemData: Object
  },
  data() {
    return {
      localData: JSON.parse(JSON.stringify(this.data)),
      storeFields: ['showCompanyName', 'showCompanyAddress', 'showCompanyPhone'],
      customerFields: ['showCustomerName', 'showCustomerPhone', 'showCustomerDebt'],
      orderAndProductFields: ['showOrderCode', 'showOrderDate', 'showCashierName', 'showProductCode', 'showUnit', 'showQuantity', 'showPrice', 'showSubtotal', 'showOrderNote'],
      paymentFields: ['showTotalAmount', 'showPaidAmount', 'showDebtAmount', 'showPaymentMethod'],
      fieldLabels: {
        showCompanyName: 'Tên cửa hàng',
        showCompanyLogo: 'Logo / Icon',
        showCompanyAddress: 'Địa chỉ',
        showCompanyPhone: 'Số điện thoại',
        showCustomerName: 'Tên khách hàng',
        showCustomerPhone: 'SĐT khách hàng',
        showCustomerDebt: 'Nợ cũ (Tổng nợ)',
        showOrderCode: 'Mã đơn hàng',
        showOrderDate: 'Ngày giờ in',
        showCashierName: 'Tên thu ngân',
        showProductCode: 'Mã SP (Code)',
        showUnit: 'Đơn vị tính',
        showQuantity: 'Số lượng',
        showPrice: 'Đơn giá',
        showSubtotal: 'Thành tiền',
        showOrderNote: 'Ghi chú đơn hàng',
        showTotalAmount: 'Tổng cộng',
        showPaidAmount: 'Khách thanh toán',
        showDebtAmount: 'Ghi nợ/Còn lại',
        showPaymentMethod: 'Hình thức TT'
      },
      sampleOrder: {
        id: 'DH-SAMPLE-123',
        createdAt: new Date().toISOString(),
        totalBill: 2449000,
        paid: 1063000,
        note: 'Giao hàng sau 2h, gọi trước khi đến',
        customer: {
          name: 'Nguyễn Văn Mẫu',
          phone: '0901234567',
          address: '456 Đường Mẫu, Quận 1, HCM',
          debtAmount: 1500000
        },
        user: { name: 'Thu Ngân A' },
        cart: [
          {
            product: { name: 'Xi măng Hà Tiên', code: 'XM001', unit: 'Kilogam' },
            quantity: 10,
            price: 95000,
            cost: 85000
          },
          {
            product: { name: 'Gạch men 60x60', code: 'GM008', unit: 'Mét' },
            quantity: 10,
            price: 150000,
            cost: 110000
          }
        ]
      }
    }
  },
  watch: {
    data: {
      handler(val) {
        this.localData = JSON.parse(JSON.stringify(val));
      },
      deep: true
    }
  },
  methods: {
    update() {
      this.$emit('update', 'invoice', this.localData);
    }
  }
}
</script>

